import axios from 'axios'
import store from '@/store'
import { Message, MessageBox } from 'element-ui'
import { getInfo, setInfo, removeInfo } from './auth'
import router from '@/router'
const i = 1

// 创建axios实例
const service = axios.create({
    baseURL: '',
    timeout: 50000 // 请求超时时间
})


//http request 拦截器
service.interceptors.request.use(
    config => {

        if (getInfo('tokens')) {
            // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = "Bearer " + getInfo('tokens');
        }

        return config;
    },
    error => {
        Message({
            message: error.message,
            type: 'error',
            duration: 3 * 1000
        })
        return Promise.reject(err);
    }
);


//http response 拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code !== 200) {
            // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
            if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
                MessageBox.alert('登录已超时', '重新登录', {
                    confirmButtonText: '重新登录',
                    closeOnClickModal: false,
                    showClose: false,
                    callback: action => {
                        store.dispatch('logout').then(() => {
                            router.replace('/home')
                            return false
                        })
                    }
                });
            } else if(res.code === 602) {
                // 提醒用户系统目前是试用版本，记得允许用户登录
                console.log('提醒用户 系统目前是试用版本')
                MessageBox.confirm(res.message || res.msg, '注意', {
                    type: 'warning',
                    showClose: false,
                    closeOnClickModal: false,
                    showConfirmButton: true,
                    showCancelButton: false,
                    closeOnPressEscape: false,
                })
                return response.data
            } else {
                Message({
                    message: res.message || res.msg,
                    type: 'error',
                    duration: 5 * 1000
                })
            }
            return Promise.reject('error')
        } else {
            return response.data
        }
    },
    error => {
        if (error.response) {
            if (error.response.status == 401) {
                if (i > 1) {
                    return false
                }
                
                store.dispatch('logout').then(() => {
                    MessageBox.alert('登录已超时', '重新登录', {
                        confirmButtonText: '确认',
                        closeOnClickModal: false,
                        showClose: false,
                        callback: action => {
                            router.replace('/home')
                            i++
                        }
                    })
                })


            } else {
                Message({
                    message: error.message,
                    type: 'error',
                    duration: 3 * 1000
                })
            }
        }

        return Promise.reject(error)
    }
)


export default service